export function ScoreBadge({ score, band, insufficient, testid }) {
  const cls =
    insufficient ? "score-badge unknown" :
    band === "high" ? "score-badge high" :
    band === "medium" ? "score-badge medium" :
    "score-badge low";
  return (
    <span className={cls} data-testid={testid || "score-badge"}>
      {insufficient || score == null ? "—" : Math.round(score)}
    </span>
  );
}

export function SourceTag({ source, url, label }) {
  const sources = {
    find_a_tender: "find a tender",
    contracts_finder: "contracts finder",
    contracts_finder_market: "contracts finder (kw)",
    public_contracts_scotland: "public contracts scotland",
    sell2wales: "sell2wales",
    etenders_ni: "etendersni",
    digital_marketplace: "digital marketplace",
    award_notices: "awards (uk)",
    ted_europa: "ted europa",
    eu_funding_tenders: "eu funding & tenders",
    nato_nspa: "nato nspa",
    occar: "occar",
    nato_sto: "nato sto",
    nato_diana: "nato diana",
    sam_gov: "sam.gov",
    us_sbir_sttr: "us sbir/sttr",
    us_defense_press: "us defense press",
    austender: "austender",
    canadabuys: "canadabuys",
    gets_nz: "gets nz",
    gov_uk_dasa: "gov.uk · dasa",
    gov_uk_defence: "gov.uk · defence",
    hansard: "hansard",
    nao: "nao",
    commons_defence_committee: "defence committee",
    parliamentary_wqa: "parliament wqa",
    mod_acquisition_pipeline: "mod acquisition pipeline",
    mod_spend: "mod spend £25k+",
    dasa_awards: "dasa awards",
    dasa_calls: "dasa calls",
    ukri: "ukri",
    innovate_uk_smart_grants: "innovate uk smart",
    ssro: "ssro",
    defence_standards: "def stan / defcon / jsp",
    trade_press: "uk defence press",
    prime_contractors: "prime contractor news",
    domestic_dual_use: "domestic dual-use",
  };
  const text = label || sources[source] || source;
  if (url) {
    return (
      <a className="source-tag" href={url} target="_blank" rel="noreferrer noopener" data-testid="source-tag-link">
        {text}
      </a>
    );
  }
  return <span className="source-tag" data-testid="source-tag">{text}</span>;
}

export function formatGBP(value, currency = "GBP") {
  if (value == null) return "—";
  try {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: currency || "GBP",
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `${value}`;
  }
}

export function relativeTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const diff = Date.now() - d.getTime();
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `${day}d ago`;
  return d.toISOString().slice(0, 10);
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d)) return null;
  const diff = d.getTime() - Date.now();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}


// Decode HTML entities (&amp; &#38; &nbsp; &quot; …) that occasionally leak
// through from upstream procurement feeds. The backend strips them at the
// /notices boundary too, but this helper is the last-line defence for any
// surface that bypasses that path (search results, dashboards, alerts).
const _decoderEl = typeof document !== "undefined" ? document.createElement("textarea") : null;
export function decodeEntities(s) {
  if (s == null) return s;
  if (typeof s !== "string") return s;
  if (!s.includes("&")) return s;
  if (_decoderEl) {
    _decoderEl.innerHTML = s;
    return _decoderEl.value;
  }
  // SSR / non-browser fallback (we don't SSR, but stay safe).
  return s
    .replace(/&amp;/g, "&")
    .replace(/&#38;/g, "&")
    .replace(/&nbsp;/g, " ")
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");
}
